import { withoutKey } from './utils.js';
export const applyScreenInfo = (screenInfo) => (state) => {
    return { ...state, screenInfo };
};
export const withoutScreenInfo = withoutKey('screenInfo');
export const selectScreenHeight = (state) => state.screenInfo?.height;
export const selectScreenWidth = (state) => state.screenInfo?.width;
